import React from 'react';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicy = () => (
  <>
    <Helmet>
      <title>Privacy Policy | nautdigital</title>
      <meta name="description" content="Read nautdigital's privacy policy to learn how we handle your data and protect your privacy." />
    </Helmet>
    <div className="container mx-auto py-16 px-4 min-h-screen">
      <h1 className="text-3xl font-bold text-white mb-6">Privacy Policy</h1>
      <p className="text-gray-300 mb-4">
        nautdigital is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
      </p>
      <h2 className="text-xl font-semibold text-white mb-2 mt-6">Information We Collect</h2>
      <ul className="list-disc list-inside text-gray-300 mb-4">
        <li>Personal identification information (name, email address, phone number, etc.)</li>
        <li>Usage data (pages visited, time spent, browser type, etc.)</li>
        <li>Any information you voluntarily provide via forms or contact methods</li>
      </ul>
      <h2 className="text-xl font-semibold text-white mb-2 mt-6">How We Use Your Information</h2>
      <ul className="list-disc list-inside text-gray-300 mb-4">
        <li>To provide, operate, and maintain our website and services</li>
        <li>To improve, personalize, and expand our offerings</li>
        <li>To communicate with you, including customer service and updates</li>
        <li>To process transactions and send related information</li>
        <li>To comply with legal obligations</li>
      </ul>
      <h2 className="text-xl font-semibold text-white mb-2 mt-6">How We Share Your Information</h2>
      <ul className="list-disc list-inside text-gray-300 mb-4">
        <li>We do not sell your personal information.</li>
        <li>We may share information with trusted third parties who assist us in operating our website and conducting our business, as long as those parties agree to keep this information confidential.</li>
        <li>We may disclose information if required by law or to protect our rights.</li>
      </ul>
      <h2 className="text-xl font-semibold text-white mb-2 mt-6">Your Rights</h2>
      <ul className="list-disc list-inside text-gray-300 mb-4">
        <li>You have the right to access, correct, or delete your personal information.</li>
        <li>You may opt out of receiving communications from us at any time.</li>
      </ul>
      <h2 className="text-xl font-semibold text-white mb-2 mt-6">Contact Us</h2>
      <p className="text-gray-300 mb-2">
        If you have any questions about this Privacy Policy or our data practices, please contact us using the <a href="/contact#contact">Contact Page</a>.
      </p>
      <p className="text-gray-300">nautdigital, London, UK</p>
      <p className="text-gray-500 text-xs mt-8">Last updated: {new Date().toLocaleDateString()}</p>
    </div>
  </>
);

export default PrivacyPolicy; 